var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"container"},[_c('div',{staticClass:"new-comics"},[_c('div',{staticClass:"image-fit"}),_c('div',{staticClass:"components"},[_c('new-comics-list')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }